import { Box, Button, Fab, useMediaQuery, useTheme } from "@mui/material";
import {
  DataGrid,
  GridActionsCellItem,
  GridCsvExportMenuItem,
  GridPrintExportMenuItem,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExportContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import axios from "axios";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { ReactSession } from "react-client-session";
import { tokens } from "../dashboard/theme";
import NavigationHeader from "../components/NavigationHeader";
import config from "./global/config";
import React from "react";
import {
  Modal,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Alert,
} from "@mui/material";
import { Add, FormatListBulleted } from "@mui/icons-material";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
  width: { xs: "90%", sm: "80%", md: "60%" },
  maxHeight: "90vh",
  overflowY: "auto",
};

// Add Categories Modal
export const AddCategoriesModal = ({
  open,
  handleClose,
  handleSubmit,
  categoriesData,
  handleChange,
  categories = [],
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Typography
          variant="h5"
          component="h2"
          sx={{ mb: 3, color: "primary.main" }}
        >
          Ajouter une nouvelle famille
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Compteur</InputLabel>
                <Select
                  name="categorie_code"
                  value={categoriesData.categorie_code || ""}
                  onChange={handleChange}
                  required
                >
                  {Array.isArray(categories) &&
                    categories.map((cat) => (
                      <MenuItem key={cat.Code} value={cat.Code}>
                        {cat.Code}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Nom Famille"
                name="nom_categories"
                value={categoriesData.nom_categories || ""}
                onChange={handleChange}
                rows={2}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description"
                name="description"
                value={categoriesData.description || ""}
                onChange={handleChange}
                multiline
                rows={2}
                required
              />
            </Grid>
          </Grid>

          <Box
            sx={{ mt: 4, display: "flex", justifyContent: "flex-end", gap: 2 }}
          >
            <Button variant="outlined" onClick={handleClose}>
              Annuler
            </Button>
            <Button variant="contained" type="submit" color="secondary">
              Enregistrer
            </Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
};

// Edit Categories Modal with the same fixes
export const EditCategoriesModal = ({
  open,
  handleClose,
  handleSubmit,
  categoriesData,
  handleChange,
  categories = [],
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Typography
          variant="h5"
          component="h2"
          sx={{ mb: 3, color: "primary.main" }}
        >
          Modifier une Famille
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Nom Famille"
                name="nom_categorie"
                value={categoriesData.nom_categorie || ""}
                onChange={handleChange}
                rows={2}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description"
                name="description"
                value={categoriesData.description || ""}
                onChange={handleChange}
                multiline
                rows={2}
                required
              />
            </Grid>
          </Grid>

          <Box
            sx={{ mt: 4, display: "flex", justifyContent: "flex-end", gap: 2 }}
          >
            <Button variant="outlined" onClick={handleClose}>
              Annuler
            </Button>
            <Button variant="contained" type="submit" color="secondary">
              Mettre à jour
            </Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
};

// Delete Categories Modal remains the same
export const DeleteCategoriesModal = ({
  open,
  handleClose,
  handleDelete,
  categories = {},
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Typography
          variant="h6"
          component="h2"
          sx={{ mb: 3, color: "error.main" }}
        >
          Confirmer la suppression
        </Typography>

        <Alert severity="warning" sx={{ mb: 3 }}>
          Êtes-vous sûr de vouloir supprimer la Famille suivant ?
        </Alert>

        <Typography variant="body1" sx={{ mb: 2 }}>
          <strong>Reference:</strong> {categories.reference || ""}
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          <strong>Nom Famille:</strong> {categories.nom_categorie || ""}
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          <strong>Description:</strong> {categories.description || ""}
        </Typography>

        <Box
          sx={{ mt: 4, display: "flex", justifyContent: "flex-end", gap: 2 }}
        >
          <Button variant="outlined" onClick={handleClose}>
            Annuler
          </Button>
          <Button variant="contained" color="error" onClick={handleDelete}>
            Supprimer
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

// Add Marques Modal
export const AddMarqueModal = ({
  open,
  handleClose,
  handleSubmit,
  marque,
  handleChange,
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Typography
          variant="h5"
          component="h2"
          sx={{ mb: 3, color: "primary.main" }}
        >
          Ajouter une nouvelle famille
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description"
                name="description"
                value={marque.description || ""}
                onChange={handleChange}
                multiline
                rows={2}
                required
              />
            </Grid>
          </Grid>

          <Box
            sx={{ mt: 4, display: "flex", justifyContent: "flex-end", gap: 2 }}
          >
            <Button variant="outlined" onClick={handleClose}>
              Annuler
            </Button>
            <Button variant="contained" type="submit" color="secondary">
              Enregistrer
            </Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
};

// Edit Marques Modal with the same fixes
export const EditMarqueModal = ({
  open,
  handleClose,
  handleSubmit,
  marque,
  handleChange,
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Typography
          variant="h5"
          component="h2"
          sx={{ mb: 3, color: "primary.main" }}
        >
          Modifier une Famille
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description"
                name="description"
                value={marque.description || ""}
                onChange={handleChange}
                multiline
                rows={2}
                required
              />
            </Grid>
          </Grid>

          <Box
            sx={{ mt: 4, display: "flex", justifyContent: "flex-end", gap: 2 }}
          >
            <Button variant="outlined" onClick={handleClose}>
              Annuler
            </Button>
            <Button variant="contained" type="submit" color="secondary">
              Mettre à jour
            </Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
};

// Delete Marques Modal remains the same
export const DeleteMarqueModal = ({
  open,
  handleClose,
  handleDelete,
  marque = {},
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Typography
          variant="h6"
          component="h2"
          sx={{ mb: 3, color: "error.main" }}
        >
          Confirmer la suppression
        </Typography>

        <Alert severity="warning" sx={{ mb: 3 }}>
          Êtes-vous sûr de vouloir supprimer la marque suivant ?
        </Alert>

        <Typography variant="body1" sx={{ mb: 2 }}>
          <strong>Description:</strong> {marque.description || ""}
        </Typography>

        <Box
          sx={{ mt: 4, display: "flex", justifyContent: "flex-end", gap: 2 }}
        >
          <Button variant="outlined" onClick={handleClose}>
            Annuler
          </Button>
          <Button variant="contained" color="error" onClick={handleDelete}>
            Supprimer
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

const MarquesGrid = ({ categorieId, isVisible }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [marques, setMarques] = useState([]);
  const [categorie, setCategorie] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const api = axios.create({
    baseURL: config.apiUrl,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  const fetchCategorie = async () => {
    try {
      const response = await api.get("categories.php", {
        params: { id_categorie: categorieId },
      });
      setCategorie(response.data[0]);
    } catch (error) {
      console.error("Error fetching categories:", error);
      if (error.response?.status === 401) {
        window.location.href = "/login";
      }
    }
  };

  const fetchMarques = async () => {
    try {
      const response = await api.get("marques.php", {
        params: { id_categorie: categorieId },
      });
      setMarques(response.data);
    } catch (error) {
      console.error("Error fetching marques:", error);
      if (error.response?.status === 401) {
        window.location.href = "/login";
      }
    }
  };

  const handleRowClick = (params) => {
    setSelectedRow(params.row);
    setIsSelected(true);
  };

  const handleAddEmptyRow = async () => {
    if (
      marques.some((row) => !row.description || row.description.trim() === "")
    ) {
      console.warn("Please complete the existing empty row first");
      return;
    }

    const newEmptyRow = {
      id_marque: `temp-${Date.now()}`,
      id_categorie: categorieId,
      nom_categorie: categorie?.nom_categorie || "",
      description: "",
      isNew: true,
    };
    setMarques((prevMarques) => [newEmptyRow, ...prevMarques]);

    try {
      const formData = new FormData();
      formData.append("id_categorie", categorieId);
      formData.append("description", "");
      formData.append("user_cre", ReactSession.get("username"));
      formData.append("METHOD", "POST");

      const response = await api.post("marques.php", formData);
      if (response.data.id_marque) {
        fetchMarques();
      }
    } catch (error) {
      console.error("Error adding marque:", error);
    }
  };

  const handleAdd = async (newRow) => {
    try {
      console.log("handleAdd: ");
      console.log(newRow);
      const formData = new FormData();
      formData.append("id_categorie", categorieId);
      formData.append("description", "");
      formData.append("user_cre", ReactSession.get("username"));
      formData.append("METHOD", "POST");

      const response = await api.post("marques.php", formData);
      console.log("response: ");
      console.log(response.data);
      if (response.data.id_marque) {
        fetchMarques();
      }
    } catch (error) {
      console.error("Error adding marque:", error);
      throw error;
    }
  };

  const handleEdit = async (newRow) => {
    try {
      const formData = new FormData();
      formData.append("id_categorie", categorieId);
      formData.append("description", newRow.description);
      formData.append("user_upd", ReactSession.get("username"));
      formData.append("METHOD", "PUT");

      await api.post(`marques.php?id_marque=${newRow.id_marque}`, formData);
      fetchMarques();
    } catch (error) {
      console.error("Error updating marque:", error);
      throw error;
    }
  };

  const handleDelete = async (id) => {
    try {
      if (id.toString().startsWith("temp-")) {
        setMarques(marques.filter((marque) => marque.id_marque !== id));
        return;
      }

      if (id) {
        const formData = new FormData();
        formData.append("METHOD", "DELETE");
        await api.post(`marques.php?id_marque=${id}`, formData);
        setMarques(marques.filter((marque) => marque.id_marque !== id));
      }
    } catch (error) {
      console.error("Error deleting marque:", error);
    } finally {
      setIsSelected(false);
    }
  };

  const columns = [
    {
      field: "nom_categorie",
      headerName: "Famille",
      flex: 1,
      editable: false,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      editable: true,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<DeleteIcon />}
          label="Delete"
          disabled={!isSelected}
          onClick={() => handleDelete(params.row.id_marque)}
          color="inherit"
        />,
      ],
    },
  ];

  useEffect(() => {
    if (isVisible && categorieId) {
      fetchMarques();
      fetchCategorie();
    }
  }, [isVisible, categorieId]);

  if (!isVisible) return null;

  return (
    <Box className="w-full h-full" display={"flex"}>
      <Box display={"flex"} justifyContent={"start"}>
        <Fab
          color="secondary"
          aria-label="add"
          size="small"
          onClick={handleAddEmptyRow}
          variant="contained"
          sx={{
            position: "absolute",
            bottom: 6,
            right: "31%",
          }}
        >
          <Add />
        </Fab>
      </Box>

      <Box
        sx={{
          height: "calc(100vh - 450px)",
          // maxHeight: "calc(100vh - 511px)",
          overflow: "hidden",
          width: "100%",
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.secondary,
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={
            marques
              ? marques.map((marque) => ({
                  id_marque: marque.id_marque,
                  id_categorie: marque.id_categorie,
                  nom_categorie: categorie.nom_categorie,
                  description: marque.description,
                }))
              : []
          }
          columns={columns}
          getRowId={(row) => row.id_marque}
          onRowClick={handleRowClick}
          editMode="row"
          onRowEditStart={(params) => {
            setIsEditing(true);
          }}
          onRowEditStop={() => {
            setIsEditing(false);
          }}
          processRowUpdate={async (newRow, oldRow) => {
            try {
              if (oldRow.isNew) {
                if (!newRow.description || newRow.description.trim() === "") {
                  throw new Error("Description cannot be empty");
                }
                await handleAdd(newRow);
              } else {
                await handleEdit(newRow);
              }
              return newRow;
            } catch (error) {
              throw error;
            }
          }}
        />
      </Box>
    </Box>
  );
}

function Categories() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [data, setData] = useState([]);
  const [dataCategorie, setDataCategorie] = useState([]);
  const [modalAdd, setModalAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modalMarque, setModalMarque] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  const [categoriesSelected, setCategoriesSelected] = useState({
    id_categorie: "",
    categorie_code: "",
    reference: "",
    nom_categorie: "",
    description: "",
    user_cre: "",
    user_upd: "",
  });

  const api = axios.create({
    baseURL: config.apiUrl,
  });

  api.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  const clearSelected = () => {
    setCategoriesSelected({
      id_categorie: "",
      categorie_code: "",
      reference: "",
      nom_categorie: "",
      description: "",
      user_cre: "",
      user_upd: "",
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCategoriesSelected((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const openCloseModalInsert = () => {
    setModalAdd(!modalAdd);
    if (!modalAdd) clearSelected();
  };

  const openCloseModalEdit = () => {
    setModalEdit(!modalEdit);
  };

  const openCloseModalDelete = () => {
    setModalDelete(!modalDelete);
  };

  const openCloseModalMarque = () => {
    setModalMarque(!modalMarque);
  };

  const requestGet = async () => {
    try {
      const response = await api.get("categories.php");
      setData(response.data);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.location.href = "/login";
      }
      console.log(error);
    }
  };

  const requestPost = async () => {
    try {
      const formData = new FormData();
      formData.append("categorie_code", categoriesSelected.categorie_code);
      formData.append("reference", categoriesSelected.reference);
      formData.append("nom_categorie", categoriesSelected.nom_categorie);
      formData.append("description", categoriesSelected.description);
      formData.append("user_cre", ReactSession.get("username"));
      formData.append("METHOD", "POST");

      const response = await api.post("categories.php", formData);

      if (
        typeof response.data === "string" &&
        response.data.includes("Error")
      ) {
        throw new Error(response.data);
      }

      if (
        Array.isArray(response.data) ||
        (typeof response.data === "object" && response.data.id_categorie)
      ) {
        requestGet();
        openCloseModalInsert();
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.location.href = "/login";
      }

      alert(error.message || "Error adding categories. Please try again.");
      console.error(error);
    }
  };

  const requestPut = async () => {
    try {
      const formData = new FormData();
      formData.append("categorie_code", categoriesSelected.categorie_code);
      formData.append("reference", categoriesSelected.reference);
      formData.append("nom_categorie", categoriesSelected.nom_categorie);
      formData.append("description", categoriesSelected.description);
      formData.append("user_upd", ReactSession.get("username"));
      formData.append("METHOD", "PUT");

      await api.post(
        `categories.php?id_categorie=${categoriesSelected.id_categorie}`,
        formData
      );
      requestGet();
      openCloseModalEdit();
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.location.href = "/login";
      }
      console.error(error);
    }
  };

  const requestDelete = async () => {
    try {
      const formData = new FormData();
      formData.append("METHOD", "DELETE");

      await api.post(
        `categories.php?id_categorie=${categoriesSelected.id_categorie}`,
        formData
      );
      setData(
        data.filter(
          (categories) =>
            categories.id_categorie !== categoriesSelected.id_categorie
        )
      );
      openCloseModalDelete();
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.location.href = "/login";
      }
      console.log(error);
    }
  };

  const selectCategories = (categories, action) => {
    setCategoriesSelected(categories);
    console.log("Selected categories:", categories);

    if (action === "Edit") {
      openCloseModalEdit();
    } else {
      openCloseModalDelete();
    }
  };

  const handleRowClick = (params) => {
    setCategoriesSelected(params.row);
    setSelectedCategoryId(params.row.id_categorie);
    setModalMarque(true);
  };

  const handleRowDoubleClick = (params) => {
    // setCategoriesSelected(params.row);
    // setSelectedCategoryId(params.row.id_categorie);
    setModalMarque(false);
  };

  const columns = [
    {
      field: "reference",
      headerName: "Reference",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "nom_categorie",
      headerName: "Nom Categorie",
      flex: 1,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      getActions: (params) => [
        <GridActionsCellItem
          icon={<EditIcon />}
          label="Edit"
          onClick={() => selectCategories(params.row, "Edit")}
          color="inherit"
        />,
        <GridActionsCellItem
          icon={<DeleteIcon />}
          label="Delete"
          onClick={() => selectCategories(params.row, "Delete")}
          color="inherit"
        />,
        <GridActionsCellItem
          icon={<FormatListBulleted />} // Use an appropriate icon for showing marques
          label="Show Marques"
          onClick={() => {
            setCategoriesSelected(params.row);
            openCloseModalMarque();
          }}
          color="inherit"
        />,
      ],
    },
  ];

  useEffect(() => {
    requestGet();
    setModalMarque(true);
  }, []);

  // Rest of the component remains the same...
  return (
    <Box m="25px">
      <NavigationHeader title="Categories" subtitle="Liste des Categories" />

      <Box display="flex" justifyContent="end" mt="20px">
        <Button
          type="submit"
          color="secondary"
          variant="contained"
          onClick={openCloseModalInsert}
        >
          Nouvelle Famille
        </Button>
        <AddCategoriesModal
          open={modalAdd}
          handleClose={openCloseModalInsert}
          handleSubmit={(e) => {
            e.preventDefault();
            requestPost();
          }}
          categoriesData={categoriesSelected}
          handleChange={handleChange}
          categories={dataCategorie}
        />

        <EditCategoriesModal
          open={modalEdit}
          handleClose={openCloseModalEdit}
          handleSubmit={(e) => {
            e.preventDefault();
            requestPut();
          }}
          categoriesData={categoriesSelected}
          handleChange={handleChange}
          categories={dataCategorie}
        />

        <DeleteCategoriesModal
          open={modalDelete}
          handleClose={openCloseModalDelete}
          handleDelete={requestDelete}
          categories={categoriesSelected}
        />
      </Box>

      {/* New horizontal layout container */}
      <Box
        display="flex"
        gap={2}
        mt="40px"
        sx={{
          height: "calc(100vh - 450px)",
          maxHeight: "calc(100vh - 420px)",
          overflow: "hidden",
          width: "100%",
          position: "relative",
        }}
      >
        {/* Categories Grid */}
        <Box
          sx={{
            width: "65%",
            transition: "width 0.1s ease",
            overflow: "auto",
            "& .MuiDataGrid-root": {
              border: "none",
              height: "100%",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.secondary,
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
            "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
              color: `${colors.grey[100]} !important`,
            },
          }}
        >
          <DataGrid
            rows={data}
            getRowId={(row) => row.id_categorie}
            columns={columns}
            // onRowDoubleClick={handleRowDoubleClick}
            onRowClick={handleRowClick}
            slots={{
              toolbar: CustomToolbar,
            }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
              },
            }}
          />
        </Box>

        {/* Marques Grid */}
        <Box
          sx={{
            width: "35%",
            overflow: "hidden",
            transition: "width 0.1s step-end",
            visibility: modalMarque ? "visible" : "hidden",
            opacity: modalMarque ? 1 : 0,
          }}
        >
          <MarquesGrid
            categorieId={selectedCategoryId}
            isVisible={modalMarque}
          />
        </Box>
      </Box>
    </Box>
  );
}

const csvOptions = {
  fileName: "CategoriesDatabase",
  delimiter: ";",
  utf8WithBom: true,
};

const printOptions = {
  hideFooter: true,
  hideToolbar: true,
  includeCheckboxes: true,
};

function CustomExportButtons(props) {
  return (
    <GridToolbarExportContainer {...props}>
      <GridCsvExportMenuItem options={csvOptions} />
      <GridPrintExportMenuItem options={printOptions} />
    </GridToolbarExportContainer>
  );
}

function CustomToolbar(props) {
  return (
    <GridToolbarContainer {...props}>
      <GridToolbarColumnsButton />
      <GridToolbarDensitySelector />
      <CustomExportButtons />
      <Box
        sx={{
          marginLeft: "auto",
          pl: 0,
          pr: 0,
          pb: 0,
          pt: 0,
        }}
      >
        <GridToolbarQuickFilter />
      </Box>
    </GridToolbarContainer>
  );
}

export default Categories;
